"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useAddressAutocomplete = void 0;
var _react = require("react");
var _constants = require("../constants");
var _models = require("../models");
var _utils = require("../utils");
var _fetchAddressSearchResult = require("../utils/useSuggestions/fetchAddressSearchResult");
var _useAddressSuggestionSearchQuery = require("../utils/useSuggestions/useAddressSuggestionSearchQuery");
const useAddressAutocomplete = ({
  country,
  minSearchLength,
  maxResults,
  api,
  setAddressToForm,
  reset,
  values,
  searchOptions,
  hasFieldError,
  fields
}) => {
  const [inputText, setInputText] = (0, _react.useState)('');
  const [suggestions, setSuggestions] = (0, _react.useState)([]);
  const [isOpen, setOpen] = (0, _react.useState)(false);
  const [selectedValue, setSelectedValue] = (0, _react.useState)(null);
  const [hasError, setHasError] = (0, _react.useState)(false);
  const [prevCountry, setPrevCountry] = (0, _react.useState)(country);
  // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions -- TODO we must fixed and checked correct working in separate story
  const newAddress = !!fields?.length;
  const addressValues = values;
  const correctCountry = addressValues.country ?? country;

  // eslint-disable-next-line react-hooks/exhaustive-deps -- we need only as is
  let resetData = {
    ..._constants.defaultValues,
    country: correctCountry
  };
  if ('address' in values) {
    resetData = {
      ...values,
      address: {
        ..._constants.defaultValues
      },
      ..._constants.defaultValues,
      country: correctCountry
    };
  }
  const handleSearch = async (searchText, pathKey) => {
    if (selectedValue && selectedValue.addressSummary === searchText) {
      return false;
    }
    setInputText(searchText);
    try {
      const suggestedAddresses = await (0, _useAddressSuggestionSearchQuery.getSuggestions)(api, minSearchLength, maxResults, searchText, correctCountry, pathKey);
      if (suggestedAddresses != null) {
        setSuggestions(suggestedAddresses);
        setOpen(true);
        return true;
      }
    } catch (error) {
      console.error('Error fetching suggestions:', error);
      return false;
    }
    return false;
  };
  const handleInputChange = (event, newInputValue) => {
    setInputText(newInputValue);
    if (newInputValue.length >= minSearchLength) {
      handleSearch(newInputValue);
      setOpen(false);
    } else {
      setSuggestions([]);
    }
  };
  const fetchFullAddress = async addressNodeId => {
    try {
      const result = await (0, _fetchAddressSearchResult.fetchAddressSearchResult)(api, addressNodeId, correctCountry);
      return result;
    } catch (error) {
      return _models.FetchResult.errorFor({
        type: 'Area'
      });
    }
  };
  const onSelectOption = async option => {
    if (option && option.pathKey == null && option.addressNodeId) {
      const address = await fetchFullAddress(option.addressNodeId);
      if (address.isSuccess() && address.response) {
        setAddressToForm((0, _utils.mapNodeToAddress)(address.response, addressValues));
        setHasError(false);
        setOpen(false);
      }
    } else {
      await handleSearch(inputText, option?.pathKey);
    }
  };
  const handleEditAddress = (0, _react.useCallback)(text => {
    const addressObject = newAddress ? {
      addressSummary: text,
      description: '',
      count: 1
    } : null;
    setSelectedValue(addressObject);
    setInputText(text);
  }, [newAddress]);
  const onChange = (_event, newValue) => {
    if (newValue === null) {
      reset({
        ...resetData
      });
    }
    setSelectedValue(newValue);
  };
  (0, _react.useEffect)(() => {
    if (searchOptions.isEnabled && hasFieldError.length > 0) {
      setHasError(true);
    }
  }, [searchOptions.isEnabled, hasFieldError]);
  (0, _react.useEffect)(() => {
    if (correctCountry && correctCountry !== prevCountry) {
      reset({
        ...resetData
      });
      setSuggestions([]);
      setPrevCountry(correctCountry);
    }
  }, [correctCountry, prevCountry, resetData, reset]);
  return {
    inputText,
    suggestions,
    isOpen,
    selectedValue,
    hasError,
    handleInputChange,
    onSelectOption,
    onChange,
    setOpen,
    handleEditAddress
  };
};
exports.useAddressAutocomplete = useAddressAutocomplete;
//# sourceMappingURL=useAddressAutocomplete.js.map